/**
 * @generated SignedSource<<1331b5abba71ddcce167805a59f049f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiscountTypeKindInput = "System" | "User";
export type discountActionsScreen_Query$variables = {
  after?: string | null;
  before?: string | null;
  filterByActionTitle?: string | null;
  filterByCode?: string | null;
  filterByDiscountTypeKind?: DiscountTypeKindInput | null;
  filterByIsArchived?: boolean | null;
  first?: number | null;
  last?: number | null;
};
export type discountActionsScreen_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"discountActionsTable_QueryFragment">;
};
export type discountActionsScreen_Query = {
  response: discountActionsScreen_Query$data;
  variables: discountActionsScreen_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByActionTitle"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByCode"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByDiscountTypeKind"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByIsArchived"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "filterByActionTitle",
    "variableName": "filterByActionTitle"
  },
  {
    "kind": "Variable",
    "name": "filterByCode",
    "variableName": "filterByCode"
  },
  {
    "kind": "Variable",
    "name": "filterByDiscountTypeKind",
    "variableName": "filterByDiscountTypeKind"
  },
  {
    "kind": "Variable",
    "name": "filterByIsArchived",
    "variableName": "filterByIsArchived"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "discountActionsScreen_Query",
    "selections": [
      {
        "args": (v8/*: any*/),
        "kind": "FragmentSpread",
        "name": "discountActionsTable_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "discountActionsScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "DiscountActionsConnection",
                "kind": "LinkedField",
                "name": "DiscountActions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DiscountActionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DiscountAction",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "percent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isReductible",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "discountType",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "kind",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "filters": [
                  "filterByDiscountTypeKind",
                  "filterByActionTitle",
                  "filterByCode",
                  "filterByIsArchived"
                ],
                "handle": "connection",
                "key": "DiscountActionsTable_DiscountActions",
                "kind": "LinkedHandle",
                "name": "DiscountActions"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fc8329c8fc413e160ed621bae8c67aea",
    "id": null,
    "metadata": {},
    "name": "discountActionsScreen_Query",
    "operationKind": "query",
    "text": "query discountActionsScreen_Query(\n  $after: String\n  $before: String\n  $filterByDiscountTypeKind: DiscountTypeKindInput\n  $filterByActionTitle: String\n  $filterByCode: String\n  $filterByIsArchived: Boolean\n  $first: Int\n  $last: Int\n) {\n  ...discountActionsTable_QueryFragment_2t73B7\n}\n\nfragment discountActionsTable_DiscountActionFragment on DiscountAction {\n  id\n  title\n  percent\n  isReductible\n  discountType {\n    __typename\n    kind\n  }\n}\n\nfragment discountActionsTable_QueryFragment_2t73B7 on Query {\n  Admin {\n    Billing {\n      DiscountActions(after: $after, before: $before, first: $first, last: $last, filterByDiscountTypeKind: $filterByDiscountTypeKind, filterByActionTitle: $filterByActionTitle, filterByCode: $filterByCode, filterByIsArchived: $filterByIsArchived) {\n        pageInfo {\n          startCursor\n          endCursor\n          hasNextPage\n          hasPreviousPage\n        }\n        edges {\n          cursor\n          node {\n            ...discountActionsTable_DiscountActionFragment\n            id\n            __typename\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7439ec9cd38ccaf8eea2da3f534778fb";

export default node;
